<section class="media">
    <h2>Principais espaços de mídia</h2>
    <p>
        <a href="https://www1.folha.uol.com.br/colunas/papo-de-responsa/2024/12/brasil-precisa-fortalecer-cultura-de-doacao-para-alem-das-crises.shtml#:~:text=No%20dia%203%20de%20dezembro,incentiva%20solidariedade%20e%20engajamento%20social"
            target="_blank">Brasil precisa fortalecer cultura de doação para além das crises</a> (Folha de São Paulo - 03/12/2024)
    </p>
    <p>
        <a target="_blank"
            href="https://www.youtube.com/watch?v=VlpKQxkRSGs&ab_channel=JornalismoTVCultura">Brasil celebra o Dia de Doar e reforça a importância da generosidade</a> (TV Cultura - 03/12/2024)
    </p>
    <p>
        <a target="_blank"
            href="https://www.jornaldocomercio.com/opiniao/2024/12/1180866-dia-de-doar-e-inclusao-juntos-por-um-proposito.html">Dia de Doar e Inclusão: juntos por um propósito</a> (Jornal do Comércio - 02/12/2024)
    </p>
    <p>
        <a target="_blank"
            href="https://noticias.r7.com/santa-catarina/nd-mais/dia-de-doar-entidades-de-criciuma-e-regiao-se-mobilizam-para-arrecadacao-29112024/">Dia de Doar: entidades de Criciúma e região se mobilizam para arrecadação</a> (R7 - 29/11/2024)
    </p>
    <p>
        <a target="_blank"
            href="https://www1.folha.uol.com.br/colunas/papo-de-responsa/2022/11/compromisso-com-a-doacao-para-mudar-o-brasil.shtml">Organizações
            do terceiro setor realizam Dia de Doar</a> (Observatório do Terceiro Setor, 2022)
    </p>
    <p>
        <a target="_blank"
            href="https://www.cnnbrasil.com.br/nacional/dia-mundial-de-doar-percentual-de-pessoas-que-fazem-doacoes-passa-de-77-para-84-em-sete-anos-diz-pesquisa/">Dia Mundial de Doar: percentual de pessoas que fazem doações passa de 77% para 84% em sete anos, diz pesquisa</a> (CNN Brasil - 29/11/2023)
    </p>
    <p>
        <a target="_blank"
            href="https://oglobo.globo.com/rio/noticia/2023/11/28/dia-de-doar-iniciativa-promove-campanhas-de-doacao-no-rio-veja-como-ajudar.ghtml">Dia de Doar: iniciativa promove campanhas de doação no Rio; veja como ajudar</a> (O Globo - 28/11/2023)
    </p>

    <p>
        <a target="_blank"
            href="https://ultimosegundo.ig.com.br/colunas/responsabilidade-com/2023-11-28/contraponto-ao-black-friday-dia-de-doar-se-fortalece-no-brasil.html#dff9adfe-e367-413c-a601-00991d9f118c">Contraponto ao Black Friday, Dia de Doar se fortalece no Brasil</a> (IG - 28/11/2023)
    </p>

    <p>
        <a target="_blank"
            href="https://valor.globo.com/brasil/noticia/2022/11/29/dia-do-doar-atrai-empresas-para-crescer.ghtml">Dia de Doar atrai empresas para crescer</a> (Valor Econômico - 29/11/2022)
    </p>
</section>